import img1 from './Image/toy1.png'
import img2 from './Image/toy2.png'
import img3 from './Image/toy3.png'

import './index.css';

const data = [
    {
        title: 'Tom Cruise',
        profession: "Actor",
        picture: img1,
        hw: 1024
    },
    {
        title: 'Donald Trump',
        profession: "Politician",
        picture: img2,
        hw: 1024
    },
    {
        title: 'Chris Hemsworth',
        profession: "Actor",
        picture: img3,
        hw: 1024
    }

]

const ContentToy = () => {

    return (
        <div className="text-white text-center">
            {
                data.map((item, index) => <div className='mb-5' key={index}>
                    <p className='fw-bold'>{item.title}</p>
                    <p>{item.profession}</p>
                    <img className='imgeAI-image' src={item.picture} alt={item.title}  ></img>
                </div>)
            }
        </div>
    );
};

export default ContentToy;
